import { CREATE_STIMULUS_CALL, UPDATE_STIMULUS_CALL } from '@instructure/quiz-common';
import { addError } from '../../common/actions/alerts';
import { handleStimuliResponse } from '../../common/api/callHandlers';
import Fetcher from '../../common/util/Fetcher';
import t from '@instructure/quiz-i18n/es/format-message';

// =====================
// =====================
//       CREATE
// =====================
// =====================

export function createStimulus(stimulus, parentId, parentType) {
  var parentStimulusId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var resource = parentType === 'bank' ? 'banks' : 'quizzes';
  var url = "/api/".concat(resource, "/").concat(parentId, "/stimuli");
  var stimulusParams = {
    orientation: stimulus.orientation,
    body: stimulus.body,
    instructions: stimulus.instructions,
    parent_stimulus_id: parentStimulusId,
    source_url: stimulus.sourceUrl,
    stimulus_type: stimulus.stimulusType,
    title: stimulus.title,
    passage: stimulus.passage
  };
  var requestBody = JSON.stringify({
    stimulus: stimulusParams
  });
  return function (dispatch, getState) {
    var fetcher = new Fetcher({
      callType: CREATE_STIMULUS_CALL,
      onError: function onError() {
        return addError(t('Failed to create stimulus.'));
      }
    });
    var createStimulusParams = {
      body: requestBody
    };
    return fetcher.post(url, createStimulusParams).then(function (stimulusData) {
      dispatch(handleStimuliResponse([stimulusData]));
      return stimulusData;
    });
  };
}

// =====================
// =====================
//       UPDATE
// =====================
// =====================

function updateStimulusParams(stimulus) {
  return {
    orientation: stimulus.orientation,
    title: stimulus.title,
    instructions: stimulus.instructions,
    body: stimulus.body,
    source_url: stimulus.sourceUrl
  };
}
export function updateStimulus(stimulus, parentId, parentType) {
  var resource = parentType === 'bank' ? 'banks' : 'quizzes';
  var url = "/api/".concat(resource, "/").concat(parentId, "/stimuli/").concat(stimulus.id);
  var reqBody = JSON.stringify({
    stimulus: updateStimulusParams(stimulus)
  });
  return function (dispatch, getState) {
    var updateStimulusParams = {
      body: reqBody
    };
    var fetcher = new Fetcher({
      callType: UPDATE_STIMULUS_CALL,
      onError: function onError() {
        return addError(t('Failed to update stimulus.'));
      }
    });
    return fetcher.patch(url, updateStimulusParams).then(function (stimulusData) {
      dispatch(handleStimuliResponse([stimulusData]));
      return stimulusData;
    });
  };
}